import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { LutienApi } from '../services/LutienApi'

type State = { organizations: any[]; isLoading: boolean; error: string | null }
const initialState: State = { organizations: [], isLoading: false, error: null }

export const getOrganizations = createAsyncThunk('lutien/getOrganizations', async () => {
  return await LutienApi.getOrganizations()
})

export const lutienSlice = createSlice({
  name: 'lutien',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getOrganizations.pending, state => {
        state.isLoading = true
      })
      .addCase(getOrganizations.fulfilled, (state, action) => {
        state.isLoading = false
        state.organizations = action.payload
      })
      .addCase(getOrganizations.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message ?? null
      })
  }
})

export default lutienSlice.reducer
